import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const buyers = [{
  name: 'María L.',
  city: 'Ciudad de México'
}, {
  name: 'Valentina R.',
  city: 'Bogotá, Colombia'
}, {
  name: 'Camila S.',
  city: 'Buenos Aires, Argentina'
}, {
  name: 'Sofía M.',
  city: 'Lima, Perú'
}, {
  name: 'Isabella G.',
  city: 'Monterrey, México'
}, {
  name: 'Daniela P.',
  city: 'Medellín, Colombia'
}, {
  name: 'Luciana T.',
  city: 'Santiago, Chile'
}, {
  name: 'Andrea V.',
  city: 'Guadalajara, México'
}, {
  name: 'Fernanda K.',
  city: 'Quito, Ecuador'
}, {
  name: 'Carolina H.',
  city: 'Santo Domingo, RD'
}, {
  name: 'Gabriela N.',
  city: 'San José, Costa Rica'
}, {
  name: 'Mariana F.',
  city: 'Puebla, México'
}];
function getRandomTime() {
  const minutes = Math.floor(Math.random() * 12) + 1;
  return `hace ${minutes} min`;
}
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(0);
  useEffect(() => {
    // First popup after 15 seconds
    const initialDelay = setTimeout(() => {
      setVisible(true);
      setTimeout(() => setVisible(false), 4000);
    }, 15000);
    // Then every 25-40 seconds
    const interval = setInterval(() => {
      setCurrentBuyer(prev => (prev + 1) % buyers.length);
      setVisible(true);
      setTimeout(() => setVisible(false), 4000);
    }, Math.random() * 15000 + 25000);
    return () => {
      clearTimeout(initialDelay);
      clearInterval(interval);
    };
  }, []);
  const buyer = buyers[currentBuyer];
  return <AnimatePresence data-id="element-248">
      {visible && <motion.div initial={{
      x: -300,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -300,
      opacity: 0
    }} transition={{
      type: 'spring',
      damping: 25,
      stiffness: 200
    }} className="fixed bottom-16 left-4 z-50 bg-[var(--card)] border border-[var(--border)] rounded-xl px-4 py-3 shadow-2xl max-w-[300px]" data-id="element-249">
          <div className="flex items-center gap-3" data-id="element-250">
            <div className="w-10 h-10 rounded-full bg-[var(--red2)] flex items-center justify-center text-white font-bold text-sm flex-shrink-0" data-id="element-251">
              {buyer.name.charAt(0)}
            </div>
            <div data-id="element-252">
              <p className="text-white text-[13px] font-semibold leading-tight" data-id="element-253">
                {buyer.name} acaba de comprar
              </p>
              <p className="text-[var(--muted)] text-[11px] mt-0.5" data-id="element-254">
                {buyer.city} · {getRandomTime()}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-1.5 mt-2" data-id="element-255">
            <span className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse" data-id="element-256" />
            <span className="text-[10px] text-[var(--muted)]" data-id="element-257">
              Verificado por Código Rojo
            </span>
          </div>
        </motion.div>}
    </AnimatePresence>;
}